<template>
  <div class="contact-us-popup">
    <div v-if="!isMobile" class="contact-us-popup__desktop">
      <BasePopover
        position="top"
        trigger="hover"
        content-class="contact-us-popup__popover"
        :content-style="desktopPopoverContentStyle"
        :overlay-style="{ zIndex: 1000 }"
        :auto-fit-position="true"
        :mouse-enter-delay="80"
        :mouse-leave-delay="200"
      >
        <slot name="trigger" />
        <template #content>
          <ContactUsPopupContent />
        </template>
      </BasePopover>
    </div>

    <template v-if="isMobile">
      <div class="contact-us-popup__trigger" @click="handleMobileTriggerClick">
        <slot name="trigger" />
      </div>

      <MobilePopup
        v-model:visible="mobileModalVisible"
        title="联系我们"
        class="contact-us-popup__mobile-popup"
      >
        <ContactUsPopupContent />
      </MobilePopup>
    </template>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useMediaQuery } from '~/composables/useMediaQuery'
import BasePopover from '~/components/base/Popover.vue'
import ContactUsPopupContent from '~/components/base/contact/ContactUsPopupContent.vue'
import MobilePopup from '~/components/mobile/Popup.vue'

const { isMobile } = useMediaQuery()
const mobileModalVisible = ref(false)

/** @type {import('vue').CSSProperties} */
const desktopPopoverContentStyle = {
  width: '400px',
  maxWidth: 'calc(100vw - 40px)',
  padding: '24px',
}

/**
 * @description 移动端点击触发
 * @returns {void}
 */
const handleMobileTriggerClick = () => {
  mobileModalVisible.value = true
}
</script>

<style lang="scss" scoped>
.contact-us-popup {
  display: inline-block;

  &__trigger {
    cursor: pointer;
  }

  &__mobile-popup {
    :deep(.base-bottom-drawer__content) {
      padding: 0 16px 16px;
    }
  }
}
</style>

<style lang="scss">
.contact-us-popup__popover {
  border: 1px solid $border-light-color;
  box-shadow: 0 4px 10px rgba($color-black, 0.1);
}
</style>
